import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { IonicModule } from '@ionic/angular';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

import { UiControls } from '@app/components/common/ui-controls.module';

import { UiUserEdit } from './user/ui-edit/ui-edit';
import { UiTableThumbnail } from './table/ui-thumb/ui-thumb';
import { UiProductThumbnail } from './product/ui-thumb/ui-thumb';
import { UiOfferThumbnail } from './offer/ui-thumb/ui-thumb';
import { UiDiscountThumbnail } from './discount/ui-thumb/ui-thumb';
import { UiExtraThumbnail } from './extra/ui-thumb/ui-thumb';
import { UiWaiterThumbnail } from './waiter/ui-thumb/ui-thumb';
import { UiTicketThumbnail } from './ticket/ui-thumb/ui-thumb';
import { UiBusinessEdit } from './client/ui-edit/ui-edit';
import { UiBusinessThumbnail } from './client/ui-thumb/ui-thumb';
import { UiPayAccountThumbnail } from './payacc/ui-thumb/ui-thumb';
import { UiTicketView }  from './ticket/ui-view/ui-view';
import { UiTicketPrint }  from './ticket/ui-print/ui-print';
import { UiTicketChange }  from './ticket/ui-change/ui-change';
import { UiTicketProduct }  from './product/ui-ticket/ui-ticket';
import { UiTicketOffer } from './offer/ui-ticket/ui-ticket';
import { UiTicketDiscount } from './discount/ui-ticket/ui-ticket';
import { UiTicketExtra } from './extra/ui-ticket/ui-ticket';
import { UiTicketEdit } from './ticket/ui-edit/ui-edit';
import { UiTicketCart } from './ticket/ui-cart/ui-cart';
import { UiInvoiceEdit } from './ticket/ui-invoice/ui-invoice';
import { UiCashPayModal } from './ticket/ui-cash/ui-cash';
import { UiCardPayModal } from './ticket/ui-card/ui-card';
import { UiCashGuardCashPayModal } from './ticket/ui-cashguard-cash/ui-cashguard-cash';
import { UiProsegurChangeModal } from './ticket/ui-prosegur-change/ui-prosegur-change';
import { UiReplenishModal } from './ticket/ui-replenish/ui-replenish';
import { UiGloryChangeModal } from './ticket/ui-glory-change/ui-glory-change';
import { UiGloryInventoryModal } from './ticket/ui-glory-inventory/ui-glory-inventory';
import { UiProsegurBackofficeModal } from './ticket/ui-prosegur-backoffice/ui-prosegur-backoffice';
import { UiCashGuardBackofficeModal } from './ticket/ui-cashguard-backoffice/ui-cashguard-backoffice';
import { UiCartProduct }  from './product/ui-cart/ui-cart';
import { UiCartOffer }  from './offer/ui-cart/ui-cart';
import { UiCartDiscount } from './discount/ui-cart/ui-cart';
import { UiCartExtra }  from './extra/ui-cart/ui-cart';
import { UiQrCodeView } from './table/ui-view/ui-view';
import { UiAreaEdit } from './table/ui-area/ui-edit';
import { UiDrawEdit } from './table/ui-draw/ui-edit';
import { UiProductView } from './product/ui-view/ui-view';
import { UiOfferView }  from './offer/ui-view/ui-view';
import { UiWaiterEdit } from './waiter/ui-edit/ui.edit';
import { UiPeriod } from './period/ui-period';
import { UiProductSelect } from './place/ui-products/ui-select';
import { UiTableSelect } from './place/ui-qrcodes/ui-select'
import { UiAmountModal } from './product/ui-count/ui-count';
import { UiOfferEdit } from './offer/ui-edit/ui-edit';
import { UiExtraEdit } from './extra/ui-edit/ui-edit';
import { UiProductEdit } from './product/ui-edit/ui-edit';
import { UiPayAccountEdit } from './payacc/ui-edit/ui-edit';
import { UiAuditPrint } from './audit/ui-print/ui-print';
import { UiAuditThumbnail } from './audit/ui-thumb/ui-thumb';
import { UiSearchNumberModal } from './place/ui-searchno/ui-searchno';
import { UiRaspPIDevices } from './rasppi/devices/ui-devices';
import { UiRaspPIThumb } from './rasppi/ui-thumb/ui-thumb';
import { UiRaspPIEdit } from './rasppi/ui-edit/ui-edit';
import { UiRaspPIView } from './rasppi/ui-view/ui-view';
import { UiPrinterDevices } from './rasppi/devices/ui-printer/ui-printer';
import { UiScaleDevices } from './rasppi/devices/ui-scale/ui-scale';
import { UiSmartDrawerDevices } from './rasppi/devices/ui-smartdrawer/ui-smartdrawer';
import { UiPaymentTerminalDevices } from './rasppi/devices/ui-payment-terminal/ui-payment-terminal';
import { UiPaytefPayModal } from './ticket/ui-paytef/ui-paytef';
import { UiPickTerminalModal } from './ticket/ui-paytef/ui-pickterminal-modal';
import { UiWaiterPin } from '@app/components/common/waiter-pin/ui-waiter-pin';
import { UiCountdownOverlay } from '@app/components/common/countdown-overlay/ui-countdown-overlay';

@NgModule({
    declarations: [
        UiUserEdit,
        UiTableThumbnail,
        UiProductThumbnail,
        UiOfferThumbnail,
        UiDiscountThumbnail,
        UiExtraThumbnail,
        UiWaiterThumbnail,
        UiTicketThumbnail,
        UiBusinessEdit,
        UiBusinessThumbnail,
        UiPayAccountThumbnail,
        UiTicketView,
        UiTicketPrint,
        UiTicketChange,
        UiTicketProduct,
        UiTicketOffer,
        UiTicketDiscount,
        UiTicketExtra,
        UiTicketEdit,
        UiTicketCart,
        UiInvoiceEdit,
        UiCashPayModal,
        UiCardPayModal,
        UiCashGuardCashPayModal,
        UiProsegurChangeModal,
        UiReplenishModal,
        UiGloryChangeModal,
        UiGloryInventoryModal,
        UiProsegurBackofficeModal,
        UiCashGuardBackofficeModal,
        UiCartProduct,
        UiCartOffer,
        UiCartDiscount,
        UiCartExtra,
        UiProductView,
        UiOfferView,
        UiQrCodeView,
        UiAreaEdit,
        UiDrawEdit,
        UiWaiterEdit,
        UiPeriod,
        UiProductSelect,
        UiTableSelect,
        UiAmountModal,
        UiOfferEdit,
        UiExtraEdit,
        UiProductEdit,
        UiPayAccountEdit,
        UiAuditPrint,
        UiAuditThumbnail,
        UiSearchNumberModal,
        UiRaspPIDevices,
        UiRaspPIThumb,
        UiRaspPIEdit,
        UiRaspPIView,
        UiPrinterDevices,
        UiScaleDevices,
        UiSmartDrawerDevices,
        UiPaymentTerminalDevices,
        UiPaytefPayModal,
        UiPickTerminalModal,
        UiWaiterPin,
        UiCountdownOverlay
    ],

    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        NgxQRCodeModule,
        IonicModule,
        UiControls
    ],

    entryComponents: [
        UiCashPayModal,
        UiCardPayModal,
        UiCashGuardCashPayModal,
        UiProsegurChangeModal,
        UiReplenishModal,
        UiGloryChangeModal,
        UiGloryInventoryModal,
        UiProsegurBackofficeModal,
        UiCashGuardBackofficeModal,
        UiPaytefPayModal,
        UiPickTerminalModal,
        UiSearchNumberModal,
        UiWaiterPin
    ],

    exports: [
        UiUserEdit,
        UiTableThumbnail,
        UiProductThumbnail,
        UiOfferThumbnail,
        UiDiscountThumbnail,
        UiExtraThumbnail,
        UiWaiterThumbnail,
        UiTicketThumbnail,
        UiPayAccountThumbnail,        
        UiTicketView,
        UiTicketEdit,
        UiTicketCart,
        UiInvoiceEdit,
        UiCartProduct,
        UiCartOffer,
        UiCartDiscount,
        UiCartExtra,
        UiTicketPrint,
        UiProductView,
        UiOfferView,
        UiQrCodeView,
        UiAreaEdit,
        UiDrawEdit,
        UiWaiterEdit,
        UiOfferEdit,
        UiExtraEdit,
        UiProductEdit,
        UiAmountModal,
        UiProductSelect,
        UiTableSelect,
        UiPayAccountEdit,
        UiAuditPrint,
        UiAuditThumbnail,
        UiRaspPIDevices,
        UiRaspPIThumb,
        UiRaspPIEdit,
        UiRaspPIView,
        UiPrinterDevices,
        UiScaleDevices,
        UiSmartDrawerDevices,
        UiWaiterPin,
        UiCountdownOverlay
    ],

    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]    
})
export class UiModel {}
